<button
	mat-icon-button
	class="drawer__content-dismiss"
	(click)="hideDrawer()"
>
	<mat-icon>close</mat-icon>
</button>
<ul class="drawer__menu">
	<li
		[ngClass]="{ 'is--active': currentSelection === Sidebar.Quote }"
		class="drawer__menu-item"
	>
		<button
			mat-icon-button
			[attr.aria-pressed]="currentSelection === Sidebar.Quote"
			matTooltip="Quote Summary"
			matTooltipPosition="left"
			matTooltipHideDelay="80"
			matTooltipClass="c-sidebar-action-text"
			aria-label="Show quote summary and/or quote breakdown sidebar"
			class="drawer__menu-action"
			(click)="changeSelection(Sidebar.Quote)"
		>
			<mat-icon class="drawer__menu-action-icon">paid</mat-icon>
		</button>
	</li>
	<li
		[ngClass]="{ 'is--active': currentSelection === Sidebar.SalesProcessTool }"
		class="drawer__menu-item"
	>
		<button
			mat-icon-button
			[attr.aria-pressed]="currentSelection === Sidebar.SalesProcessTool"
			matTooltip="Sales Process Tool"
			matTooltipPosition="left"
			matTooltipHideDelay="80"
			matTooltipClass="c-sidebar-action-text"
			aria-label="Show sales process tool"
			class="drawer__menu-action"
			(click)="changeSelection(Sidebar.SalesProcessTool)"
		>
			<mat-icon class="drawer__menu-action-icon">speaker_notes</mat-icon>
		</button>
	</li>
	<li
		[ngClass]="{ 'is--active': currentSelection === Sidebar.Notes }"
		class="drawer__menu-item"
	>
		<button
			mat-icon-button
			[attr.aria-pressed]="currentSelection === Sidebar.Notes"
			matTooltip="Important Notes"
			matTooltipPosition="left"
			matTooltipHideDelay="80"
			matTooltipClass="c-sidebar-action-text"
			aria-label="Show Notes"
			class="drawer__menu-action"
			(click)="changeSelection(Sidebar.Notes)"
		>
			<mat-icon class="drawer__menu-action-icon">description</mat-icon>
		</button>
	</li>
</ul>
<section
	[ngClass]="{ 'is--open': isOpen }"
	class="drawer__content"
>
	<ng-container [ngSwitch]="currentSelection">
		<ng-container *ngSwitchCase="Sidebar.Quote">
			<app-quote-breakdown *ngIf="sessionStarted$ | async">
				<app-quote-drawer-heading></app-quote-drawer-heading>
			</app-quote-breakdown>
			<div
				*ngIf="!(sessionStarted$ | async)"
				class="drawer__content-no-data"
			>
				<img
					src="assets/images/sidebarEmpty.svg"
					alt="Image of space dog displayed when there is no sidebar information"
				/>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="Sidebar.Notes">
			<app-quote-important-notes>
				<app-quote-drawer-heading></app-quote-drawer-heading>
			</app-quote-important-notes>
		</ng-container>
		<ng-container *ngSwitchCase="Sidebar.SalesProcessTool">
			<app-sales-process-tool>
				<app-quote-drawer-heading></app-quote-drawer-heading>
			</app-sales-process-tool>
		</ng-container>
	</ng-container>
	<!-- <div
		*ngIf="!(sessionStarted$ | async)"
		class="drawer__content-no-data"
	>
		<img
			src="assets/images/sidebarEmpty.svg"
			alt="Image of space dog displayed when there is no sidebar information"
		/>
	</div> -->
</section>
